import fetchGroupOutcomes from './fetchGroupOutcomes';

export default function fetchGroupCaseOutcomes(groupId, serviceTypeId, params = {}) {
  return fetchGroupOutcomes(groupId, serviceTypeId, {
    ...params,
  });
}
